import { Redirect, Route, Switch } from "wouter";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import { AppShell } from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Sellers from "@/pages/Sellers";
import SellerDetail from "@/pages/SellerDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Categories from "@/pages/Categories";
import Coupons from "@/pages/Coupons";
import Billing from "@/pages/Billing";
import Orders from "@/pages/Orders";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import Data from "@/pages/Data";
import AiSettings from "@/pages/AiSettings";
import NotFound from "@/pages/NotFound";

function FullScreenLoader() {
  return (
    <div className="flex h-viewport items-center justify-center bg-background">
      <Loader2 className="size-6 animate-spin text-primary" />
      <span className="sr-only">Carregando</span>
    </div>
  );
}

export default function App() {
  const { user, isAdmin, isLoading } = useAuth();

  if (isLoading) return <FullScreenLoader />;

  // A checagem é única, aqui: nenhuma tela verifica permissão por conta
  // própria. Se cada uma checasse, uma delas acabaria esquecendo.
  //
  // A defesa de verdade está no backend (o custom claim `admin` verificado
  // pelas callables e pelas regras do Firestore). Esta checagem é de
  // apresentação: sem ela, quem não é administrador veria telas vazias e erros
  // de permissão em vez de uma explicação.
  if (!user || !isAdmin) return <Login />;

  return (
    <AppShell>
      {/* Do mais especifico para o mais generico: o Switch casa a primeira. */}
      <Switch>
        <Route path="/vendedores/:id" component={SellerDetail} />
        <Route path="/vendedores" component={Sellers} />
        <Route path="/clientes/:id" component={ClientDetail} />
        <Route path="/clientes" component={Clients} />
        <Route path="/tipos-de-produto" component={Categories} />
        {/* Endereço antigo da mesma tela, para favorito e link já compartilhado. */}
        <Route path="/categorias">
          <Redirect to="/tipos-de-produto" replace />
        </Route>
        <Route path="/cupons" component={Coupons} />
        <Route path="/faturamento" component={Billing} />
        <Route path="/pedidos" component={Orders} />
        <Route path="/notificacoes" component={Notifications} />
        <Route path="/configuracoes" component={Settings} />
        <Route path="/dados" component={Data} />
        <Route path="/ia" component={AiSettings} />
        <Route path="/" component={Dashboard} />
        <Route component={NotFound} />
      </Switch>
    </AppShell>
  );
}
